module.exports = __webpack_public_path__ + "static/media/farmer-on-the-frontline-thumbnail_tablet.69c48844.jpg";